export default __webpack_public_path__ + "static/media/cat-cafe-shop.8aada2b9.png";